import React from 'react';
import './Home.css';
import Hero from '../../Components/Hero/Hero';
import Contact from '../Contact/Contact';
import ServicesSection from '../../Components/ServicesSection/ServicesSection';
import VideoBlock from '../../Components/VideoBlock/VideoBlock';
import WhyUs from '../../Components/WhyUs/WhyUs';

function Home() {
  return (
    <div className="home-container">

    <Hero />

    <VideoBlock />  
    <WhyUs />    
    <ServicesSection />
  



      <div id="contact" style={{ scrollMarginTop: '100px' }}>
        <Contact />
      </div>

    </div>
  );
}

export default Home;
